import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { createBenefitProgram } from 'Services/JOONAdmin/benefitProgramCategoriesService'

export const useCreateBenefitProgramQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.CreateBenefitProgram], createBenefitProgram, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerBenefitPrograms])
        toast.success(AppNotification.CreateBenefitProgramSuccess)
      } else {
        toast.error(`${AppNotification.CreateBenefitProgramFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.CreateBenefitProgramFailure)
    }
  })
}
